// Generated by scripts/i18n/controllerMessages.mjs (run by `yarn i18n:extract`). Do not edit.
// English messages from ambire-common, matched at runtime by translateControllerMessage().
/* eslint-disable */
import { i18nKey } from './constants'

export const CONTROLLER_MESSAGES: readonly string[] = [
  i18nKey("/app/routers responded {{status}}"),
  i18nKey("4337 invalid account nonce"),
  i18nKey("A malicious transaction found in this batch."),
  i18nKey("Account balance and asset prices may be inaccurate."),
  i18nKey("Account balance and visible assets may be inaccurate."),
  i18nKey("Account creation properties are missing"),
  i18nKey("Account details missing. Please try again"),
  i18nKey("Account details needed for the signing mechanism are not found. Please try again, re-import your account or contact support if nothing else helps."),
  i18nKey("Account not found"),
  i18nKey("Account op passed for simulation but the nonce did not increment. Perhaps wrong nonce set in Account op"),
  i18nKey("Account with address {{addr}} not found. Please try again or contact support if the problem persists."),
  i18nKey("AccountPickerController init failed: missing initParams."),
  i18nKey("Add this token’s network to your wallet before swapping it."),
  i18nKey("Address Book: can't remove contact that doesn't exist in the Address Book"),
  i18nKey("Address Book: can't rename contact that doesn't exist in the Address Book"),
  i18nKey("Address Book: contact with this address already exists in the Address Book"),
  i18nKey("Address Book: failed to load contacts from the Address Book"),
  i18nKey("Address Book: invalid address"),
  i18nKey("Address encrypt returned an unexpected shape"),
  i18nKey("Affected features: visible assets, DeFi positions, sign message/transaction, ENS domain resolving, add account."),
  i18nKey("Amount adjusted to cover blockchain fees"),
  i18nKey("Another function is already being handled by withStatus refrain from invoking a second function."),
  i18nKey("App not unlocked. Please try again or contact support if the problem persists."),
  i18nKey("Auto-login failed. Please sign the message manually."),
  i18nKey("Automatic asset discovery is temporarily unavailable"),
  i18nKey("Base account is required for simulation"),
  i18nKey("Blind Signing is disabled on your Ledger device. To sign this transaction, please enable Blind Signing (formerly called Contract Data) in the Ethereum app settings on your Ledger device, then try again."),
  i18nKey("Broadcast failed because of a pending transaction. Please try again"),
  i18nKey("Broadcasting ZKX v1 transactions is possible only by using an EOA. Import or create one to broadcast your transactions."),
  i18nKey("Broadcasting transactions is possible only using an external account. Import or create one to broadcast your Safe transactions"),
  i18nKey("Bundler broadcast failed. Please try broadcasting by an EOA or contact support."),
  i18nKey("Bundler estimation failed"),
  i18nKey("Bundler settings error"),
  i18nKey("CCTP hub (USDC-BASE router) is not loaded — load /app/routers first"),
  i18nKey("Can't pull operations"),
  i18nKey("Can't pull operations: {{e}}"),
  i18nKey("Can't remove contact that doesn't exist in the Address Book"),
  i18nKey("Can't rename contact that doesn't exist in the Address Book"),
  i18nKey("Can't request magic link for email {{email}}. Please try again or contact support if the problem persists."),
  i18nKey("Can't request magic link for email {{email}}: {{message}}"),
  i18nKey("Can't request magic link for email {{email}}: {{message}}. Please try again or contact support if the problem persists."),
  i18nKey("Candide API key is not set"),
  i18nKey("Cannot connect to your Ledger device. Close all other apps that may be accessing it (including apps on your computer). Ensure device is responsive. Ensure Ledger firmware and Ethereum App are up to date. Device error: {{error}}"),
  i18nKey("Cannot connect to your Ledger device. Please make sure it is connected."),
  i18nKey("Cannot connect to your Ledger device. Please make sure it is unlocked and running the Ethereum app."),
  i18nKey("Cannot swap {{symbol}} to the same token."),
  i18nKey("Cannot update balance changes for {{identifier}}: network mismatch"),
  i18nKey("Circle fee lookup failed ({{status}})"),
  i18nKey("Closing the Trezor popup interrupted the connection."),
  i18nKey("Contact with this address already exists in the Address Book"),
  i18nKey("Contract name not found"),
  i18nKey("Could not connect to your Trezor device. Please try again."),
  i18nKey("Could not establish connection with the Ledger device"),
  i18nKey("Could not fetch a fallback price for a Gas Tank token."),
  i18nKey("Could not fetch gas prices, retrying..."),
  i18nKey("Could not fetch the gas price for the native swap fee reserve"),
  i18nKey("Could not initialize WalletConnect connection. Please try again later or contact ZKX support."),
  i18nKey("Could not initialize connection with your Lattice1 device. Please try again later or contact ZKX support."),
  i18nKey("Could not initialize connection with your Ledger device. Please try again later or contact ZKX support."),
  i18nKey("Could not initialize connection with your QR hardware wallet. Please try again later or contact ZKX support."),
  i18nKey("Could not initialize connection with your Trezor device. Please try again later or contact ZKX support."),
  i18nKey("Could not refresh the native swap fee reserve"),
  i18nKey("Could not report the bridge to LibertySwap"),
  i18nKey("Could not report the swap transaction to ZKX Trade"),
  i18nKey("Could not verify your password. Please try again or contact support if the problem persists."),
  i18nKey("Could not verify {{updatedCount}} transaction(s) on chain {{keyAsChainId}} - no provider for it."),
  i18nKey("Couldn't Process Request"),
  i18nKey("Currently, the ZKX relayer seems to be temporarily down. Please try again a few moments later"),
  i18nKey("Currently, the relayer seems to be down. Please try again a few moments later or broadcast with an EOA account"),
  i18nKey("Currently, {{symbol}} is unavailable as a fee token as we're experiencing troubles fetching its price. Please select another or contact support"),
  i18nKey("DEX router data not available for same-chain swap. Please try again."),
  i18nKey("DeFi position available on {{formattedNetworkNames}}"),
  i18nKey("DeFi positions available on {{formattedNetworkNames}}"),
  i18nKey("Delegate call to an unverified contract"),
  i18nKey("Delegation detected"),
  i18nKey("Dex routers request failed with status {{status}}"),
  i18nKey("Dex routers response is not a list"),
  i18nKey("During the preparation step, required transaction information was found missing (account state). Please try again later or contact support."),
  i18nKey("Either 'message' or 'typedData' must be provided."),
  i18nKey("Email Vault recovers your password. It is securely stored in ZKX's infrastructure cloud."),
  i18nKey("Email key not confirmed"),
  i18nKey("Enable All"),
  i18nKey("Enable password reset via email"),
  i18nKey("Entropy pool is empty"),
  i18nKey("Error detected in the pending batch. Please review it before proceeding"),
  i18nKey("Error getting email vault for {{email}} {{message}}"),
  i18nKey("Error in emailVault.handleMagicLinkKey: {{error}}"),
  i18nKey("Error in signAccountOp.traceCall"),
  i18nKey("Error removing keystore secret from email vault"),
  i18nKey("Error updating the SignAccountOpController"),
  i18nKey("Error upload keyStore to email vault"),
  i18nKey("Error while executing the 'get' function in the portfolio library on {{name}} ({{chainId}})"),
  i18nKey("Error while executing the 'get' function in the portfolio library on {{name}} ({{chainId}}) for account {{accountId}}."),
  i18nKey("Error while fetching DeFi apps data from Velcro for account {{addr}}."),
  i18nKey("Error while fetching exchange list: {{message}}"),
  i18nKey("Error while fetching portfolio discovery data from Velcro for account {{addr}} on chainId {{chainId}}."),
  i18nKey("Error while initializing portfolio lib for {{name}} ({{chainId}})."),
  i18nKey("Error while updating token validation for {{address}} ({{chainId}})."),
  i18nKey("Error: TransactionManagerController feature is not enabled"),
  i18nKey("Error: signAccountOp controller not initialized while trying to sign and broadcast"),
  i18nKey("Error: this.#survey does not exist when attempting to submit answers"),
  i18nKey("Error: this.answers does not exist when attempting to submit answers"),
  i18nKey("Estimation race condition prevented"),
  i18nKey("Estimation race condition prevented. Op id: {{id}}. Expected: {{lastAccountOpId}}"),
  i18nKey("Etherspot API key is not set"),
  i18nKey("EventEmitter: Trying to register a controller while the registry is not set."),
  i18nKey("EventEmitter: Trying to register a controller while the registry is not set. Controller: {{name}}"),
  i18nKey("Extension not unlocked. Please try again or contact support if the problem persists."),
  i18nKey("Failed estimating gas for broadcast: the nonce {{nonce}} is behind the chain (the RPC reports {{foundNonce}})"),
  i18nKey("Failed to decrypt message. Error details: <{{e}}>"),
  i18nKey("Failed to determine transaction status on network with id {{chainId}} for {{txnId}}."),
  i18nKey("Failed to fetch DEX config."),
  i18nKey("Failed to fetch account onchain state for network with chainId {{chainId}}"),
  i18nKey("Failed to fetch address name"),
  i18nKey("Failed to fetch and update addresses blacklisted status"),
  i18nKey("Failed to fetch and update domains blacklisted status"),
  i18nKey("Failed to fetch contract selectors"),
  i18nKey("Failed to fetch exchange list: {{statusText}}"),
  i18nKey("Failed to fetch gas price on {{name}}: {{message}}"),
  i18nKey("Failed to fetch survey"),
  i18nKey("Failed to fetch the bundler estimation"),
  i18nKey("Failed to fetch token blacklist: {{message}}"),
  i18nKey("Failed to fetch token blacklist: {{statusText}}"),
  i18nKey("Failed to focus the request window. Please restart your browser if the issue persists."),
  i18nKey("Failed to get names of addresses because the request to the relayer failed."),
  i18nKey("Failed to load the last used fee payment selection"),
  i18nKey("Failed to open a new request window. Please restart your browser if the issue persists."),
  i18nKey("Failed to open request window. If the issue persists, please reject the request and try again."),
  i18nKey("Failed to read the onchain nonce while reconciling a pending transaction on network with id {{chainId}}."),
  i18nKey("Failed to record that survey is answered locally"),
  i18nKey("Failed to record the EOA transaction to the relayer."),
  i18nKey("Failed to record the surveyId locally as responded to: this.#surveysRespondedTo was missing"),
  i18nKey("Failed to remove account"),
  i18nKey("Failed to remove account key"),
  i18nKey("Failed to reorder accounts. Please reload the page and try again."),
  i18nKey("Failed to retrieve DeFi positions for {{providerName}} on {{value}}"),
  i18nKey("Failed to retrieve DeFi positions on {{value}}"),
  i18nKey("Failed to retrieve asset prices for DeFi positions on {{value}}"),
  i18nKey("Failed to retrieve information about the Safe. Please try again"),
  i18nKey("Failed to retrieve network data for {{networkName}} (RPC malfunction)"),
  i18nKey("Failed to retrieve network data for {{networkName}}. You can try selecting another RPC URL"),
  i18nKey("Failed to retrieve network data for {{value}} (RPC malfunction)"),
  i18nKey("Failed to retrieve prices"),
  i18nKey("Failed to retrieve the portfolio data"),
  i18nKey("Failed to scan token transfer logs on network with id {{chainIdString}}."),
  i18nKey("Failed to scan token transfer logs on network with id {{chainId}}."),
  i18nKey("Failed to scan token transfer receipts on network with id {{chainIdString}}."),
  i18nKey("Failed to store the last used fee payment selection"),
  i18nKey("Failed to submit response."),
  i18nKey("Failed to submit your answer, please contact support"),
  i18nKey("Failed to update account state for {{name}}"),
  i18nKey("Failed to update phishing (status: {{status}}, url: {{url}})"),
  i18nKey("Fee options are temporarily limited"),
  i18nKey("First time sending to this address."),
  i18nKey("From token at {{fromTokenAddress}} on chain {{fromChainId}} not found in LibertySwap."),
  i18nKey("Gas price information is currently unavailable. This may be due to network congestion or connectivity issues. Please try again in a few moments or check your internet connection."),
  i18nKey("Getting the private key from the seed phrase failed."),
  i18nKey("Got status {{status}} from the API."),
  i18nKey("Hex string must have an even number of characters"),
  i18nKey("Incorrect derivation path when trying to update the temp seed. Please contact support"),
  i18nKey("Incorrect password. Please try again."),
  i18nKey("Incorrect password. Use the password of the device you are syncing from."),
  i18nKey("Insufficient balance to cover both the amount and the gas fee."),
  i18nKey("Insufficient balance."),
  i18nKey("Insufficient balance. Keep about {{value}} {{symbol}} for the network fee."),
  i18nKey("Insufficient funds to cover the fee."),
  i18nKey("Insufficient {{nativeSymbol}} balance to cover the bridge amount."),
  i18nKey("Insufficient {{nativeSymbol}} balance to cover the swap amount."),
  i18nKey("Insufficient {{nativeSymbol}}. This bridge imposes a fee that must be paid in {{nativeSymbol2}}."),
  i18nKey("Insufficient {{nativeSymbol}}. This swap imposes a fee that must be paid in {{nativeSymbol2}}."),
  i18nKey("Internal error from bundler"),
  i18nKey("Internal error: The signing process was not initialized as expected. Please try again later or contact ZKX support if the issue persists."),
  i18nKey("Invalid QR hardware wallet payload. Please try again."),
  i18nKey("Invalid RPC URL provided"),
  i18nKey("Invalid address"),
  i18nKey("Invalid address."),
  i18nKey("Invalid amount."),
  i18nKey("Invalid bytes-like string in call data."),
  i18nKey("Invalid checksum. Verify the address and try again."),
  i18nKey("Invalid fee call: missing `to` field"),
  i18nKey("Invalid to address in call."),
  i18nKey("It looks like that this app doesn't detect Smart Account wallets, and requested incompatible approval type. Please, go back to the app and change the approval type to \"Transaction\", which is supported by Smart Account wallets."),
  i18nKey("Key with address {{missingKeyAddr}} for account with address {{accAddr}} not found. 'Please try again or contact support if the problem persists.'"),
  i18nKey("Keystore integrity check failed. Your stored data may have been tampered with. Please contact support."),
  i18nKey("Keystore recovery: email {{email}} not imported"),
  i18nKey("Keystore recovery: magic link expired for {{email}}"),
  i18nKey("Keystore recovery: no keystore secret for email {{email}}"),
  i18nKey("Keystore recovery: no keystore secret for this device"),
  i18nKey("Keystore recovery: retrieveKeyStoreSecret doesn't return result or result.value."),
  i18nKey("Keystore security upgrade will be retried on next unlock."),
  i18nKey("Keystore signer, signMessage: passed value is not a hex"),
  i18nKey("Keystore unexpected error. If the problem persists, please contact support."),
  i18nKey("Last transaction to this address was {{value}}."),
  i18nKey("Ledger device busy. Please make sure there are no pending requests on the device."),
  i18nKey("Ledger device got disconnected. Please reconnect and try again."),
  i18nKey("LibertySwap is unavailable right now: its router list could not be loaded. Please try again in a moment."),
  i18nKey("LibertySwap {{base}} API base is not configured — set {{value}} in .env"),
  i18nKey("Loading is taking longer than expected"),
  i18nKey("Looks like there is an error while processing your sign message. Please retry, or contact support if issue persists."),
  i18nKey("Minimum amount is ${{amount}}."),
  i18nKey("Minimum amount is {{value}} {{symbol}}."),
  i18nKey("Missing from token address in route."),
  i18nKey("Missing gas fee payment details. Please try again or contact support if the problem persists."),
  i18nKey("Missing hdPathTemplate"),
  i18nKey("Missing mandatory account data. Please try again later."),
  i18nKey("Missing mandatory transaction data (account state). Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Missing mandatory transaction data (gas prices). Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Missing mandatory transaction details (account state). Please try again or contact support if the problem persists."),
  i18nKey("Missing mandatory transaction details. Please try again or contact support if the problem persists."),
  i18nKey("Missing to token address in route."),
  i18nKey("Missing token balance snapshot for {{value}} at block {{blockNumber}}"),
  i18nKey("Missing trace result for HyperEVM transaction {{hash}}"),
  i18nKey("Missing transaction hash for HyperEVM native balance change trace"),
  i18nKey("NULL token address detected while updating or initializing the Swap & Bridge controller."),
  i18nKey("Network connection issue prevented us from retrieving the current network fee."),
  i18nKey("Network details missing. Please try again"),
  i18nKey("Network not supported on Ambire. Please contract support."),
  i18nKey("Network not supported on ZKX. Please contract support."),
  i18nKey("Network with chainId {{chainId}} not found"),
  i18nKey("Network with chainId {{chainId}} not found while discarding simulation results."),
  i18nKey("Network with chainId: {{chainId}} not found"),
  i18nKey("Network with id {{chainId}} not found. Please try again or contact support if the problem persists."),
  i18nKey("Network/provider not found for chainId: {{chainId}}"),
  i18nKey("New assets may not be visible in your portfolio. You can add assets manually or wait for the issue to be resolved."),
  i18nKey("No DEX quote data available. Please request a quote first."),
  i18nKey("No PulseChain intermediate token mapping for {{id}}."),
  i18nKey("No bridge contract found for {{id}}."),
  i18nKey("No internal key available for signing"),
  i18nKey("No keys available to sign this transaction."),
  i18nKey("No on-chain bridge router for token {{inputTokenId}}"),
  i18nKey("No proxy ambire account mined for the specified network"),
  i18nKey("No questions in survey"),
  i18nKey("No route found for {{symbol}} → {{symbol2}}. Try a different amount or token."),
  i18nKey("No survey"),
  i18nKey("No sync request for key {{key}}"),
  i18nKey("No transaction response received after being broadcasted."),
  i18nKey("Non address passed to ContractNamesController.getName"),
  i18nKey("Non-address passed to ContractNamesController.getName: {{_address}}, {{chainId}}"),
  i18nKey("Nonce discrepancy, perhaps there's a pending transaction. Retrying..."),
  i18nKey("Old ZKX Account"),
  i18nKey("On-chain RAILGUN shield requires an encrypted 0zk recipient"),
  i18nKey("One time nonce could not be encoded because paymaster data is missing"),
  i18nKey("Only HD paths with up to 5 indices are allowed."),
  i18nKey("Our service provider LiFi is temporarily unavailable or your internet connection is too slow."),
  i18nKey("Our service provider LiFi is temporarily unavailable."),
  i18nKey("Our service provider LiFi received too many requests, temporarily preventing your request from being processed."),
  i18nKey("Our service provider Socket is temporarily unavailable or your internet connection is too slow."),
  i18nKey("Our service provider Squid is not configured yet. Error details: <missing SQUID_INTEGRATOR_ID>"),
  i18nKey("Our service provider Squid is temporarily unavailable or your internet connection is too slow."),
  i18nKey("Our service provider ZKX Trade is temporarily unavailable or your internet connection is too slow."),
  i18nKey("Our service provider received too many requests, temporarily preventing your request from being processed. {{errorPrefix}}"),
  i18nKey("Our service providers are currently unavailable. Please try again later."),
  i18nKey("Our service providers are temporarily unavailable or your internet connection is too slow."),
  i18nKey("Our third-party providers don't support this network yet, so we cannot show token prices."),
  i18nKey("Partially submitted"),
  i18nKey("Paymaster call timeout"),
  i18nKey("Paymaster is not responding. Retrying..."),
  i18nKey("Paymaster not configured. Please contact support"),
  i18nKey("Pending broadcast. Please try again in a bit."),
  i18nKey("Pending swap action"),
  i18nKey("Pending transaction detected. Please try again in a few seconds"),
  i18nKey("Pending transfer action"),
  i18nKey("Permission not granted."),
  i18nKey("Pimlico API key is not set"),
  i18nKey("Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Please complete the pending swap action."),
  i18nKey("Please complete the pending transfer action."),
  i18nKey("Please enable {{name}} from settings -> networks to sign messages on it"),
  i18nKey("Please open the Ethereum app on your Ledger device first."),
  i18nKey("Please remove all invalid calls if you want to proceed."),
  i18nKey("Please select a signer."),
  i18nKey("Please select a token and an account for paying the gas fee."),
  i18nKey("Please set \"Safety checks\" to \"Prompt\" in Trezor Suite (Settings - Device) to use your Trezor (with Ledger Live HD paths) as a key for your Ambire smart account. This is flagged as non-standard and blocked otherwise."),
  i18nKey("Please set \"Safety checks\" to \"Prompt\" in Trezor Suite (Settings - Device) to use your Trezor on HyperEVM chain. This is flagged as non-standard and blocked otherwise."),
  i18nKey("Please try again or contact support if the problem persists."),
  i18nKey("Please unlock your Ledger device first."),
  i18nKey("Please wait for the completion of the previous action before initiating another one, {{callName}}"),
  i18nKey("Please wait for the completion of the previous action before initiating another one."),
  i18nKey("Please wait, the signing/broadcasting process of this transaction is already in progress."),
  i18nKey("Provider for chainId: {{chainId}} not found"),
  i18nKey("Provider for {{networkName}} not found. Please try again or contact support if the problem persists."),
  i18nKey("Provider not found"),
  i18nKey("Provider not found for network {{value}}"),
  i18nKey("Questions are not an array"),
  i18nKey("Questions have wrong format"),
  i18nKey("Queued pending transactions are available on your Dashboard."),
  i18nKey("Quote API timeout"),
  i18nKey("Quote requested, but Squid only supports swaps on Citrea and bridges to or from Citrea."),
  i18nKey("Quote requested, but missing required params. Error details: <from token details are missing>"),
  i18nKey("Quote requested, but missing required params. Error details: <to token details are missing>"),
  i18nKey("RAILGUN Fast-shield is not supported on chain {{outputChainId}}"),
  i18nKey("RAILGUN shield is not supported on output chain {{outputChainId}}"),
  i18nKey("RPC error"),
  i18nKey("RPC error. Please try again"),
  i18nKey("Railgun swap: destination address is required to build the memo"),
  i18nKey("Railgun swap: output token address is required to build the memo"),
  i18nKey("Re-quoted 4337 fee {{amount}} exceeds the available {{availableAmount}} of {{symbol}} (chainId {{chainId}})"),
  i18nKey("Read-only"),
  i18nKey("Received route with no routeId"),
  i18nKey("Received route with no routeId from {{name}}. From: {{address}} ({{chainId}}) To: {{address2}} ({{chainId2}})"),
  i18nKey("Recipient encoding must fit in 255 bytes"),
  i18nKey("Recovery Phrase 1"),
  i18nKey("Recurring task failed"),
  i18nKey("Rejected by your Ledger device."),
  i18nKey("Rejected by your Trezor device."),
  i18nKey("Relayer call to /v2/config/networks timed out after 5000ms"),
  i18nKey("Replacement fee is insufficient. Fees have been automatically adjusted so please try submitting your transaction again."),
  i18nKey("Request rejected - empty calls array not allowed!"),
  i18nKey("Request to relayer failed"),
  i18nKey("Required account data couldn't be retrieved. Please try again later or contact support."),
  i18nKey("Resetting the password on this device is not enabled for {{email}}."),
  i18nKey("Retrieving internal keys failed. Please try to start the process of selecting accounts again. If the problem persist, please contact support."),
  i18nKey("Route data is missing."),
  i18nKey("SIWE autologin - signedMessage is null"),
  i18nKey("Safe not activated on {{name}}. Please activate it from Safe Global"),
  i18nKey("Scroll down to view the failed transaction."),
  i18nKey("Scroll down to view the failed transactions."),
  i18nKey("Scroll down to view the pending transaction."),
  i18nKey("Scroll down to view the pending transactions."),
  i18nKey("Select at least one account to sync."),
  i18nKey("Selecting {{addr}} account failed because the details for this account are missing. Please try again or contact support if the problem persists."),
  i18nKey("Set a password for this device before syncing your accounts."),
  i18nKey("Should NEVER happen: Error while calculating projected rewards stats"),
  i18nKey("SignAccountOpController: The controller is not initialized while we are trying to build GasFeePayment."),
  i18nKey("SignAccountOpController: fee speed not selected"),
  i18nKey("SignAccountOpController: fee token not selected"),
  i18nKey("SignAccountOpController: paying account not selected"),
  i18nKey("SignAccountOpController: paying option not found"),
  i18nKey("Signer key not supported on this network"),
  i18nKey("Signer with address {{addr}} does not have privileges to execute this operation. Please choose a different signer and try again"),
  i18nKey("Significant Account Balance Decrease"),
  i18nKey("Significant Account Balance Decrease (Possibly Inaccurate)"),
  i18nKey("Signing EIP-7702 authorization via this flow is not implemented"),
  i18nKey("Signing failed. Error details: {{e}}"),
  i18nKey("Signing is not possible with the selected account's token as it doesn't have sufficient funds to cover the gas payment fee."),
  i18nKey("Signing messages is disallowed for v1 accounts. Please contact support to proceed"),
  i18nKey("Signing this eip-712 message is disallowed for v1 accounts as it does not contain the smart account address and therefore deemed unsafe"),
  i18nKey("Simulation reverted"),
  i18nKey("Smart Accounts are not available on the destination network, so funds bridged there could not be moved. Choose another destination or use a Basic (EOA) account."),
  i18nKey("Smart Accounts supported (new address)"),
  i18nKey("Smart contract wallets are not supported"),
  i18nKey("Solana recipients are not supported for CCTP swaps"),
  i18nKey("Something goes wrong while we are resetting your password! Please try again! If the problem persists, please contact support"),
  i18nKey("Something went wrong when initiating the Keystore. Please try again or contact support if the problem persists."),
  i18nKey("Something went wrong when loading portfolio. Please try again or contact support if the problem persists."),
  i18nKey("Something went wrong when loading the Address Book. Please try again or contact support if the problem persists."),
  i18nKey("Something went wrong when loading the Keystore. Please try again or contact support if the problem persists."),
  i18nKey("Something went wrong when preparing your request. Please try again later or contact ZKX support. Error details: <{{errorDetails}}>"),
  i18nKey("Something went wrong when saving your keys. Please try again or contact support if the problem persists."),
  i18nKey("Something went wrong when trying to unlock ZKX. Please try again or contact support if the problem persists."),
  i18nKey("Something went wrong while setting up the gas fee payment account and token. Please try again, selecting the account and token option. If the problem persists, contact support."),
  i18nKey("Something went wrong while verifying {{email}}. Please try again in a moment."),
  i18nKey("Something went wrong with deriving the accounts. Please start the process again. If the problem persists, contact support."),
  i18nKey("Something went wrong with finding the corresponding account in the associated keys of the linked account with address {{addr}}."),
  i18nKey("Something went wrong with finding the corresponding account in the associated keys of the linked account with address {{addr}}. Please start the process again. If the problem persists, contact support."),
  i18nKey("Sponsorship error, request too slow"),
  i18nKey("Sponsorship failed."),
  i18nKey("Step 1/2 preparing account"),
  i18nKey("Step 2/2 signing transaction"),
  i18nKey("Survey is not object"),
  i18nKey("Swap provider misconfiguration"),
  i18nKey("Sync Key Store keys"),
  i18nKey("That activation link is not valid or has already been used for {{email}}. Request a new link and try again."),
  i18nKey("The HD path template is missing. Please try to start the process of selecting accounts again. If the problem persist, please contact support."),
  i18nKey("The Message was successfully signed."),
  i18nKey("The RPC provider for Ethereum is not available."),
  i18nKey("The Safe account is not deployed on any of your enabled networks that have Safe support: {{value}}. Please deploy it from Safe Global on at least one network before continuing"),
  i18nKey("The account state of {{accountAddr}} is missing for the network with id {{chainId}}."),
  i18nKey("The account you are using is an old ZKX Account that was intended for testing the extension only. Fee options aren't available on custom networks. It won't be supported in the future. Please migrate to another by creating a new smart account in the extension or contact the team for support"),
  i18nKey("The address {{addr}} can't be verified to be a smart account address."),
  i18nKey("The address {{addr}} is not linked to a ZKX account. Please try again later or contact support if the problem persists."),
  i18nKey("The address {{addr}} is not linked to a ZKX account. This could be because the identity data is missing in the identities table but could exist in the logs table."),
  i18nKey("The amount must be greater than 0.{{value}}1."),
  i18nKey("The execution of {{funcName}} in SelectedAccountController failed"),
  i18nKey("The execution of {{funcName}} in the AccountPickerController failed"),
  i18nKey("The fee offered for this transaction does not cover its broadcast cost, so it was rejected. Retrying will not help — please pay the fee with another token."),
  i18nKey("The liquidity provider declined this route. Please try again."),
  i18nKey("The minimum top up is ${{value}} (≈ {{value2}} {{symbol}})."),
  i18nKey("The network you are trying to add has already been added."),
  i18nKey("The price moved more than the allowed slippage while you were confirming. Refresh the quote and try again."),
  i18nKey("The primaryType is missing in the typed data message incoming. Please try again with a valid EIP712 message."),
  i18nKey("The requested network(s) are not supported by any available service provider. Chain IDs: {{value}}"),
  i18nKey("The same token cannot be used as both the source and destination."),
  i18nKey("The scanned QR codes do not contain ZKX accounts, or not all of them were scanned. Please try again."),
  i18nKey("The selected speed is not available due to insufficient funds. Please select a slower speed."),
  i18nKey("The signing/broadcasting process is already in progress. (signAndBroadcast func). Status: {{status}}. BroadcastStatus: {{broadcastStatus}}. Signing key: {{signingKeyType}}. Fee payer key: {{paidByKeyType}}. Type: {{#type}}."),
  i18nKey("The swap route is missing its token or aggregator, so its transaction cannot be verified. Refresh the quote and try again."),
  i18nKey("The swap was blocked because ZKX Trade returned a transaction the wallet could not verify: <{{reason}}>"),
  i18nKey("The time allotted for changing your password has expired for {{email}}. Please verify your email again!"),
  i18nKey("The token you are trying to swap is not supported by our service provider. Please select another token."),
  i18nKey("The transaction fee rose to {{value}} {{symbol}} while preparing the broadcast, which is more than the {{value2}} {{symbol2}} this account holds. Please pay the fee with another token and try again."),
  i18nKey("The transaction is missing essential data. Please contact support."),
  i18nKey("The transaction was submitted but its hash could not be confirmed in time. Check Activity before retrying - it may still go through."),
  i18nKey("The transaction you are about to sign contains an unknown token. Please review carefully, as this token may be misleading."),
  i18nKey("The transaction you are about to sign may significantly decrease your account balance. However, due to temporary issues in discovering new portfolio tokens, this information might not be fully accurate. Please review the transaction details carefully."),
  i18nKey("The transaction you are about to sign will override the existing EIP-7702 delegation on your account. Are you sure you want to proceed?"),
  i18nKey("The transaction you are about to sign will significantly decrease your account balance. Please review the transaction details carefully."),
  i18nKey("The {{kind}} signing method is not supported by signMessageController."),
  i18nKey("There was an error while updating the sign message request. Please try again."),
  i18nKey("There was error fetching the survey."),
  i18nKey("This account has no signing keys added therefore it is in a view-only mode. Make a request for keys sync from another device."),
  i18nKey("This account uses a key type ({{keyType}}) that does not support getting encryption public key."),
  i18nKey("This address isn't in your Address Book. Double-check the details before confirming."),
  i18nKey("This dApp asked for a gasless token approval (EIP-2612 permit / EIP-3009 authorization), which is verified by the token contract itself and only accepts a plain EOA signature. Smart Accounts cannot sign it. Please switch to a Basic (EOA) account and try again."),
  i18nKey("This feature is currently disabled"),
  i18nKey("This network supports Smart Accounts and ZKX Wallet's contracts are deployed, but there is no EIP-7702 here: a Smart Account gets a NEW address. Gas Tank top-ups and spending go through the ZKX relayer, which the backend enables per chain."),
  i18nKey("This network supports Smart Accounts, and ZKX Wallet's smart contracts are deployed."),
  i18nKey("This network supports Smart Accounts, but ZKX Wallet's contracts have not yet been deployed. You can deploy them by using an EOA account and the deploy contracts option to unlock the Smart Accounts feature. Otherwise, only EOA accounts can be used on this network."),
  i18nKey("This quote has expired and no new route is available right now. Please try again."),
  i18nKey("This quote has expired. Refresh to get a new one."),
  i18nKey("This token is found on {{networkNames}}. Is the correct network selected?"),
  i18nKey("This token is not supported by our service provider."),
  i18nKey("This token type is not supported"),
  i18nKey("To token at {{toTokenAddress}} on chain {{toChainId}} not found in LibertySwap."),
  i18nKey("Token amount too low."),
  i18nKey("Token blacklist response returned success: false"),
  i18nKey("Token list on the receiving network is temporarily unavailable."),
  i18nKey("Token prices"),
  i18nKey("Token validation failed: unable to fetch required token data"),
  i18nKey("Token with this address is not supported by our service provider."),
  i18nKey("Token {{id}} is not eligible for on-chain RAILGUN shield"),
  i18nKey("Token {{symbol}} is supported by LibertySwap, but not on chain {{chainId}}. Please re-select the token."),
  i18nKey("Token {{symbol}} on chain {{chainId}} is not supported by LibertySwap."),
  i18nKey("Token {{symbol}} on chain {{fromChainId}} is not supported for cross-chain by LibertySwap."),
  i18nKey("Transaction cannot be sent because the 24kb call data size limit has been reached. Please use StateOverride mode instead."),
  i18nKey("Transaction couldn't be processed because required account data couldn't be retrieved. Please try again later or contact ZKX support."),
  i18nKey("Transaction failed."),
  i18nKey("Transaction fees changed. Please try again"),
  i18nKey("Transaction is pending onchain confirmation."),
  i18nKey("Transaction queued"),
  i18nKey("Transaction receipt {{txnId}} was not found"),
  i18nKey("Transaction simulation"),
  i18nKey("Transaction simulation helps predict the outcome of a transaction and your future account balance before it’s broadcasted to the blockchain, enhancing security."),
  i18nKey("Transaction simulation helps predict the outcome of a transaction and your future account balance before it’s broadcasted to the blockchain, enhancing security. Unfortunately, this feature isn't available for the current network or RPC. Try choosing a different RPC."),
  i18nKey("Transaction simulation is fully supported"),
  i18nKey("Transaction simulation is not supported"),
  i18nKey("Transaction simulation is partially supported"),
  i18nKey("Transaction simulation, one of our security features that predicts the outcome of a transaction before it is broadcast to the blockchain, is not fully functioning on this chain. The reasons might be network or RPC limitations. Try choosing a different RPC."),
  i18nKey("Transactions are pending onchain confirmation."),
  i18nKey("Transactions failed."),
  i18nKey("Trezor device busy. Please make sure there are no pending requests on the device."),
  i18nKey("Trezor device got disconnected."),
  i18nKey("Trying to broadcast an ERC-4337 request but userOperation is not set for the account with address {{accAddr}}"),
  i18nKey("Trying to select {{addr}} account, but this account was not found in the accountsOnPage or it's keys were not found."),
  i18nKey("Trying to unlock ZKX, but the lock mechanism was not fully configured yet. Please try again or contact support if the problem persists."),
  i18nKey("Unable to connect to the ZKX relayer. Please try again later. Error code: RELAYERCALL_NOT_BINDED"),
  i18nKey("Unable to estimate the transaction fee as fetching the latest price update for the network native token failed. Please try again later."),
  i18nKey("Unable to estimate the transaction fee in USD."),
  i18nKey("Unable to find gas tank fee token for symbol {{symbol}} and network {{chainId}}"),
  i18nKey("Unable to get DEX quote for {{symbol}} → {{symbol2}} on PulseChain."),
  i18nKey("Unable to get DEX quote for {{symbol}} → {{symbol2}}. The pair may not be supported."),
  i18nKey("Unable to proceed with the transfer due to missing information (account state). Please try again later."),
  i18nKey("Unable to sign the message. During the preparation step, required account data failed to get received. Please try again later or contact ZKX support."),
  i18nKey("Unable to sign the transaction. During the preparation step, required account key information was found missing. Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Unable to sign the transaction. During the preparation step, required information about paying the gas fee was found missing. Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Unable to sign the transaction. During the preparation step, required signing key information was found missing. Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Unable to sign the transaction. During the preparation step, required transaction information was found missing (account state). Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Unable to sign the transaction. During the preparation step, the necessary transaction data was not received. Please attempt to initiate the transaction again or contact ZKX support."),
  i18nKey("Unable to start the route. Error details: <missing transaction request data>"),
  i18nKey("Unexpected /app/routers response shape"),
  i18nKey("Unexpected error while building intent request"),
  i18nKey("Unexpected error while building transfer request"),
  i18nKey("Unexpected swap & bridge error: no quote found. Please contact support"),
  i18nKey("Unfortunately, this network doesn't support Smart Accounts. It can be used only with EOA accounts."),
  i18nKey("Unknown token detected"),
  i18nKey("Unlock the app before syncing your accounts."),
  i18nKey("Unrecognized policy status"),
  i18nKey("Unsupported recipient type: {{value}}"),
  i18nKey("Use the \"Retry\" button to try again, or pay the fee with the native token\""),
  i18nKey("Use this estimation only for smart accounts"),
  i18nKey("UserRequest not found. Id: {{requestId}}"),
  i18nKey("UserRequest not found. Index: {{requestIndex}}"),
  i18nKey("We are missing required information to continue. Refresh and submit the form again."),
  i18nKey("We can't find an email vault for {{email}}. Double-check the address or start a new setup."),
  i18nKey("We couldn't check the addresses or tokens in this transaction for malicious activity. Proceed with caution."),
  i18nKey("We couldn't create your email vault for {{email}}. Please try again in a moment."),
  i18nKey("We couldn't retrieve the latest network fee information."),
  i18nKey("We pull token price information in real-time using third-party providers."),
  i18nKey("We were unable to detect Smart Account support on the network with the provided RPC. Try choosing a different RPC."),
  i18nKey("We were unable to fetch the network information with the provided RPC. Try choosing a different RPC."),
  i18nKey("Wrong format for contract selectors"),
  i18nKey("Wrong surveyId type"),
  i18nKey("You are about to delegate permissions to a contract not whitelisted by Safe. Proceed with caution"),
  i18nKey("You are not logged in with {{email}} on this device."),
  i18nKey("You are trying to send tokens to a smart contract. Doing so would burn them."),
  i18nKey("You are trying to store an invalid seed phrase."),
  i18nKey("You can only broadcast transactions for ZKX v1 accounts from an EOA"),
  i18nKey("You can proceed safely, but fee payment options are limited due to a pending transaction"),
  i18nKey("You can proceed, but fee estimation is outdated - consider waiting for an updated estimation for a more optimal fee."),
  i18nKey("You can't send to the same address you’re sending from."),
  i18nKey("You have a pending transaction on this network. Please wait for it to complete before signing another one."),
  i18nKey("You need to broadcast pending transactions before this one."),
  i18nKey("You're about to send funds back to yourself."),
  i18nKey("Your Ledger device requires a firmware and Ethereum App update."),
  i18nKey("Your Ledger doesn't recognize the command sent. Please update device firmware and Ethereum App and try again."),
  i18nKey("Your activation link expired for {{email}}. Submit the form to get a new link."),
  i18nKey("Your funds are safe, but your portfolio will be inaccurate. You can add assets manually or wait for the issue to be resolved."),
  i18nKey("ZKX Smart Accounts"),
  i18nKey("ZKX Smart Accounts via ERC-4337 (Account Abstraction)"),
  i18nKey("ZKX Trade API base is not configured — set ZKX_TRADE_API_URL in .env"),
  i18nKey("ZKX Trade returned a plan with no transaction to execute. Please try again."),
  i18nKey("ZKX Trade returned a plan without swap transaction data. Please try again."),
  i18nKey("ZKX does not support this request format for signing messages. Please contact support if you believe could be a glitch."),
  i18nKey("ZKX failed to validate the signature. Please make sure you are signing with the correct key or device. If the problem persists, please contact ZKX support."),
  i18nKey("ZKX failed to validate the signature. Please make sure you are signing with the correct key or device. If the problem persists, please contact ZKX support. Error details: unexpected result from the UniversalValidator: {{callResult}}"),
  i18nKey("ZKX failed to validate the signature. Please make sure you are signing with the correct key or device. If the problem persists, please contact ZKX support. Error details:: {{value}}"),
  i18nKey("ZKX only supports signing EIP712 typed data messages. Please try again with a valid EIP712 message."),
  i18nKey("ZKX relayer error timeout"),
  i18nKey("ZKX v1 accounts are not supported on this network. To interact with this network, please use a Smart Account or an EOA account. You can still use v1 accounts on any network that is natively integrated with the ZKX web and mobile wallets."),
  i18nKey("ZKX was not able to retrieve the signature. Please try again or contact support if the problem persists."),
  i18nKey("[PORTFOLIO_ACTIVITY_BLOCK_MISMATCH] Portfolio block is behind confirmed Activity block"),
  i18nKey("[SwapAndBridge] no confirmed txnId for {{type}}:{{identifier}} — order and tx/process not sent"),
  i18nKey("a portfolio library is not initialized for {{name}} ({{chainId}})"),
  i18nKey("accountPicker: #deriveAccounts called, but keyIterator was missing"),
  i18nKey("accountPicker: account {{addr}} was not found in the accountsOnPage."),
  i18nKey("accountPicker: createAndAddEmailAccount called, but failed to derive the public key address."),
  i18nKey("accountPicker: missing hdPathTemplate"),
  i18nKey("accountPicker: missing keyIterator"),
  i18nKey("accountPicker: missing retrieveInternalKeys method"),
  i18nKey("accountPicker: requested a method of the AccountPicker controller, but the controller was not initialized"),
  i18nKey("accountPicker: selectNextAccount called, but no next account found."),
  i18nKey("accounts: Failed to create smart account identities for: {{value}}"),
  i18nKey("accounts: Identity created for {{addr}} which lacks creation data."),
  i18nKey("accountsSync: account {{addr}} does not match its creation data"),
  i18nKey("accountsSync: account {{addr}} has unexpected associatedKeys"),
  i18nKey("accountsSync: external key {{addr}} has a privKey"),
  i18nKey("accountsSync: failed to decompress the payload: {{msg}}"),
  i18nKey("accountsSync: invalid account addr"),
  i18nKey("accountsSync: invalid account associatedKeys"),
  i18nKey("accountsSync: invalid account initialPrivileges"),
  i18nKey("accountsSync: invalid account preferences"),
  i18nKey("accountsSync: invalid creation data for account {{addr}}"),
  i18nKey("accountsSync: invalid key addr"),
  i18nKey("accountsSync: invalid key type"),
  i18nKey("accountsSync: invalid keys"),
  i18nKey("accountsSync: invalid scrypt params"),
  i18nKey("accountsSync: invalid seed hd path {{id}}"),
  i18nKey("accountsSync: invalid seed id"),
  i18nKey("accountsSync: invalid seeds"),
  i18nKey("accountsSync: invalid transport key encryption"),
  i18nKey("accountsSync: key {{addr}} has no meta"),
  i18nKey("accountsSync: missing the password protected transport key"),
  i18nKey("accountsSync: missing the payload MAC"),
  i18nKey("accountsSync: no accounts in the payload"),
  i18nKey("accountsSync: the payload is too large to be a sync payload"),
  i18nKey("accountsSync: the scanned data is not a valid sync payload"),
  i18nKey("accountsSync: unsupported payload version {{v}}"),
  i18nKey("accountsSync: {{what}} is not encrypted with the expected scheme"),
  i18nKey("activity: no provider for chainId {{keyAsChainId}}"),
  i18nKey("address or token"),
  i18nKey("addresses or tokens"),
  i18nKey("bad method"),
  i18nKey("body hash did not verify"),
  i18nKey("broadcast failed"),
  i18nKey("buildUserRequestFromIntentRequest: bad parameters passed to buildIntentUserRequest"),
  i18nKey("buildUserRequestFromTransferRequest: bad parameters passed to buildTransferUserRequest"),
  i18nKey("bundler estimation request too slow"),
  i18nKey("bundler gas price fetch fail, request too slow"),
  i18nKey("bundler gas request too slow"),
  i18nKey("call init first"),
  i18nKey("callContractAndSendResToUi: network not found"),
  i18nKey("callContractAndSendResToUi: not a valid Contract method"),
  i18nKey("callProviderAndSendResToUi: not a valid provider method"),
  i18nKey("callProviderAndSendResToUi: provider not found"),
  i18nKey("cena error for {{url}}: {{value}}"),
  i18nKey("cena responded with {{status}} for {{url}}"),
  i18nKey("currently, we cannot fetch the coingecko information"),
  i18nKey("custom bundler not set"),
  i18nKey("domains.resolveDomain: Ethereum provider is not available"),
  i18nKey("domains.reverseLookup: Ethereum provider is not available"),
  i18nKey("error removing keyStore secret from email vault"),
  i18nKey("error retrieving data for email vault"),
  i18nKey("error upload keyStore to email vault"),
  i18nKey("eth_estimateGas timed out"),
  i18nKey("evmPush: data too long"),
  i18nKey("evmPush: no data"),
  i18nKey("gas fee payment cannot be paid by anyone other than the EOA that signed it"),
  i18nKey("gas fee payment needs to be in the native asset"),
  i18nKey("gas fee payment with gas tank cannot be used with an EOA"),
  i18nKey("getProxyDeployBytecode: internal: offset>256"),
  i18nKey("getProxyDeployBytecode: max 3 privLevels"),
  i18nKey("internal error: queue length and response length mismatch"),
  i18nKey("invalid address"),
  i18nKey("keyIterator: invalid argument provided to constructor"),
  i18nKey("keyIterator: invalid or missing arguments"),
  i18nKey("keyIterator: no private key or seed phrase provided"),
  i18nKey("keystore seed with id:{{id}} not found"),
  i18nKey("keystore: adding secret before get uid"),
  i18nKey("keystore: export for sync while locked"),
  i18nKey("keystore: failed to add queued keys"),
  i18nKey("keystore: failed to getMainKeyEncryptedWithSecrets() from storage"),
  i18nKey("keystore: hd path to temp seed incorrect"),
  i18nKey("keystore: import from sync while locked"),
  i18nKey("keystore: item MAC verification failed"),
  i18nKey("keystore: key does not have privateKey"),
  i18nKey("keystore: key not found"),
  i18nKey("keystore: must unlock keystore before adding secret"),
  i18nKey("keystore: needs to be unlocked"),
  i18nKey("keystore: no password secret to sync with"),
  i18nKey("keystore: no secrets yet"),
  i18nKey("keystore: no seed phrase added yet"),
  i18nKey("keystore: no temp seed at the moment"),
  i18nKey("keystore: not unlocked"),
  i18nKey("keystore: per-item IV migration failed"),
  i18nKey("keystore: secret not found"),
  i18nKey("keystore: secret not found for verifyPassword ({{secretId}})"),
  i18nKey("keystore: secret$ {{secretId}} not found"),
  i18nKey("keystore: synced key {{addr}} does not match its address"),
  i18nKey("keystore: synced seed {{id}} is not a valid seed phrase"),
  i18nKey("keystore: the synced data failed its integrity check"),
  i18nKey("keystore: trying to add an invalid seed phrase"),
  i18nKey("keystore: trying to add duplicate secret {{secretId}}"),
  i18nKey("keystore: trying to remove key that does not exist: address: {{addr}}, type: {{type}}"),
  i18nKey("keystore: unsupported cipherType {{cipherType}}"),
  i18nKey("keystore: unsupported signer type"),
  i18nKey("keystore: verifyPassword mac mismatch"),
  i18nKey("keystore: wrong encryptedSk or private key"),
  i18nKey("keystore: wrong password for the synced transport key"),
  i18nKey("keystoreSigner: no decrypted private key provided in constructor"),
  i18nKey("keystoreSigner: no key provided in constructor"),
  i18nKey("last block failed to resolve, request too slow"),
  i18nKey("main: invalid accounts sync payload"),
  i18nKey("main: no accounts to sync"),
  i18nKey("main: the sync payload is not hex"),
  i18nKey("missing gasFeePayment"),
  i18nKey("missing gasLimit"),
  i18nKey("missing nonce"),
  i18nKey("missing signature"),
  i18nKey("missing signingKeyAddr"),
  i18nKey("network not set, did you call init?"),
  i18nKey("no available bundlers to switch"),
  i18nKey("no key to perform sign"),
  i18nKey("no native fee payment option, it should not happen"),
  i18nKey("no receipts found"),
  i18nKey("no response"),
  i18nKey("no response entry for request ({{value}})"),
  i18nKey("no url or path"),
  i18nKey("no userTxs in selectedRoute"),
  i18nKey("normalizeSignatureHex: invalid signature payload"),
  i18nKey("normalizeSignatureHex: missing signature fields"),
  i18nKey("operation aborted"),
  i18nKey("portfolio controller: no res, should never happen"),
  i18nKey("portfolio.discardSimulation: Network with chainId {{chainId}} not found"),
  i18nKey("price proxy responded with {{status}}"),
  i18nKey("provider not set, did you call init?"),
  i18nKey("recordBridgeActivity: no chainId found"),
  i18nKey("recordBridgeActivity: no provider found"),
  i18nKey("recordBridgeActivity: no receipt found for txnId: {{txnId}}"),
  i18nKey("removeKeyStoreSecret: not confirmed magic link key"),
  i18nKey("removeUserRequests: tried to run for non-existent account {{accountAddr}}"),
  i18nKey("request-timeout"),
  i18nKey("requestsController error: accountState for {{accountAddr}} is undefined on network with id {{chainId}}"),
  i18nKey("requestsController error: accountState for {{addr}} is undefined on network with id {{chainId}}"),
  i18nKey("requestsController: Cannot add a new request (addUserRequests) while a signing or broadcasting process is still running."),
  i18nKey("route not set"),
  i18nKey("rpcUrls must be a non-empty array"),
  i18nKey("settings: addNetwork chain already added (duplicate id/chainId)"),
  i18nKey("should not have a body"),
  i18nKey("signMessage: controller not initialized"),
  i18nKey("signMessage: missing message to sign"),
  i18nKey("signMessage: missing selected signer"),
  i18nKey("signature error: trying to sign a readable operation for the same address. Please contact support"),
  i18nKey("signing not set"),
  i18nKey("simulation error: Failed to increment the nonce to the final account op nonce"),
  i18nKey("simulation error: lower \"after\" nonce, should not be possible"),
  i18nKey("single txn broadcast misconfig"),
  i18nKey("state override mode (or auto-detect) not available unless you use JsonRpcProvider"),
  i18nKey("state override passed but not requested"),
  i18nKey("swap quote failed ({{status}})"),
  i18nKey("swap&bridge simulation failed"),
  i18nKey("timed out, race timer resolved first"),
  i18nKey("unable to find contract named {{contractName}} in output from file {{contractName2}}: perhaps the name of the file is different compared to the name of the contract?"),
  i18nKey("unable to retrieve block"),
  i18nKey("unexpected status {{status}}"),
  i18nKey("uploadKeyStoreSecret: not confirmed magic link key"),
  i18nKey("wrong account passed"),
  i18nKey("{{accountAddr}} is not found in accounts. Account count: {{accountsCount}}"),
  i18nKey("{{accountId}} is not found in accounts. Account count: {{accountsCount}}"),
  i18nKey("{{addedCallsCount}} new transaction was added to this batch by the app. Review all of them before signing."),
  i18nKey("{{addedCallsCount}} new transactions were added to this batch by the app. Review all of them before signing."),
  i18nKey("{{callsCount}} transactions queued"),
  i18nKey("{{errorPrefix}} Error details: <Unexpected non-JSON response from our service provider Squid>, message: <{{message}}>"),
  i18nKey("{{errorPrefix}} Error details: <Unexpected non-JSON response from our service provider>, message: <{{message}}>"),
  i18nKey("{{errorPrefix}} Our service provider LiFi could not be reached: <{{message}}>{{status}}"),
  i18nKey("{{errorPrefix}} Our service provider LiFi responded: <{{fallbackMessage}}>"),
  i18nKey("{{errorPrefix}} Our service provider Squid could not be reached: {{status}}"),
  i18nKey("{{errorPrefix}} Our service provider Squid responded: <{{upstreamMessage}}>"),
  i18nKey("{{errorPrefix}} Our service provider ZKX Trade responded with an error: <{{detail}}>, status: <{{status}}>"),
  i18nKey("{{errorPrefix}} The liquidity provider declined this route: <{{detail}}>"),
  i18nKey("{{errorPrefix}} Upstream error: <{{message}}>{{status}}"),
  i18nKey("{{errorPrefix}} ZKX Trade rejected the accepted amount for this route: <{{detail}}>"),
  i18nKey("{{message}} Automatically retrying in a few seconds. Please wait..."),
  i18nKey("{{message}} We will continue retrying, but please check your internet connection."),
  i18nKey("{{methodName}}: state override requested but not supported"),
  i18nKey("{{method}} is not a valid JsonRpcProvider method"),
  i18nKey("{{requestsCount}} transactions are mutually exclusive (Same nonce). You can sign only one."),
  i18nKey("{{symbol}} detected in batch. Please complete the batch before bridging"),
  i18nKey("{{value}} is not a valid Contract method"),
  i18nKey("🔔 A route was found for this pair but the minimum token amount was not met."),
]

// Keys of i18nMessage() in ambire-common, translated by translateI18nText().
export const I18N_MESSAGE_KEYS: readonly string[] = [
  i18nKey("Ambire API data providers report {{count}} more DeFi positions.", { count: 0 }),
  i18nKey("Automatic asset discovery is temporarily unavailable on {{networks}}"),
  i18nKey("Bridges completed", { count: 0 }),
  i18nKey("Bridges in progress", { count: 0 }),
  i18nKey("DeFi positions available on {{networks}}", { count: 0 }),
  i18nKey("Enable All"),
  i18nKey("Enable these networks to include them?", { count: 0 }),
  i18nKey("Enable this network to include them?", { count: 0 }),
  i18nKey("Enable {{networks}}"),
  i18nKey("Failed bridges", { count: 0 }),
  i18nKey("Failed swaps", { count: 0 }),
  i18nKey("Failed to retrieve prices on {{networks}}"),
  i18nKey("Failed to retrieve the portfolio data on {{networks}}"),
  i18nKey("Loading is taking longer than expected on {{networks}}"),
  i18nKey("Refunded bridges", { count: 0 }),
  i18nKey("Refunded swaps", { count: 0 }),
  i18nKey("Swaps completed", { count: 0 }),
  i18nKey("Swaps in progress", { count: 0 }),
  i18nKey("You have {{count}} completed bridges.", { count: 0 }),
  i18nKey("You have {{count}} completed swaps.", { count: 0 }),
  i18nKey("You have {{count}} failed bridges.", { count: 0 }),
  i18nKey("You have {{count}} failed swaps.", { count: 0 }),
  i18nKey("You have {{count}} pending app requests", { count: 0 }),
  i18nKey("You have {{count}} pending bridges.", { count: 0 }),
  i18nKey("You have {{count}} pending signature requests", { count: 0 }),
  i18nKey("You have {{count}} pending swaps.", { count: 0 }),
  i18nKey("You have {{count}} refunded bridges.", { count: 0 }),
  i18nKey("You have {{count}} refunded swaps.", { count: 0 }),
  i18nKey("{{count}} transactions waiting to be signed", { count: 0 }),
  i18nKey("{{count}} transactions waiting to be signed on {{network}}", { count: 0 }),
]
